import { useMemo } from 'react';
import useAppStore from '../store/appStore';
import useAdminStore from '../store/adminStore';
import { resolveClientFullName, resolveDisplayMandantNr } from '../utils/clientIdentity';

export const useClientIdentity = (userData?: any) => {
    const clientData = useAppStore((state) => state.clientData);
    const team = useAppStore((state) => state.team);
    const { crmClients, impersonatedClientId } = useAdminStore();

    const godModeId = typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('GOD_MODE_ID') : null;
    const activeClientId = impersonatedClientId || godModeId;

    const godModeClient = useMemo(
        () => (activeClientId ? crmClients.find((c) => c.id === activeClientId) : null),
        [crmClients, activeClientId]
    );

    const fullName = useMemo(
        () => resolveClientFullName({ godModeClient, userData, clientData }),
        [godModeClient, userData, clientData]
    );

    const mandantNr = useMemo(() => {
        const raw =
            godModeClient?.mandantNr ||
            godModeClient?.clientData?.mandantNr ||
            userData?.mandantNr ||
            userData?.clientData?.mandantNr ||
            clientData?.mandantNr ||
            '';
        const betreuer = godModeClient?.betreuer || userData?.betreuer || clientData?.betreuer || '';
        return resolveDisplayMandantNr(raw, betreuer, team);
    }, [godModeClient, userData, clientData, team]);

    return { fullName, mandantNr, godModeClient };
};
